export enum AcaoTagsEnum {
    Incluir = 1,
    Remover = 2,
}
